import { Footer } from './SupportInfoFooter.styles';

export function SupportInfoFooter() {
  return (
    <Footer>
      <div className="footer-container">
        Centro de consultas: 4379-3330 o 0810-222-7342.
      </div>
    </Footer>
  );
}
